// The static sections of /creators, in page order. The copy is the approved static build's, word for word.

import styles from "../CreatorsPage.module.scss";
import { Bookmark, Chevron, Comment, Compass, Document, Esim, Heart, Instagram, Link, MapPin, SMark, Star } from "./icons";
import { img } from "./images";
import { CREATOR_PAGE_PATH } from "./links";

export const Why = () => (
	<section aria-labelledby="why-h" className={styles.why2}>
		<div className={styles.wrap}>
			<div className={styles.secHead}>
				<span className={styles.eyebrow}>Why Stippl</span>
				<h2 className={styles.h2} id="why-h">
					Your tips <span className={styles.hl}>get used.</span>
				</h2>
			</div>
			<div className={styles.w2grid}>
				<article className={`${styles.w2} ${styles.act} ${styles.wide}`}>
					<div className={styles.w2T}>
						<span className={styles.w2K}>
							<Compass fill="#ea5681" /> Actionable content
						</span>
						<h3>Not just saved, but travelled</h3>
						<p>Your places land straight in their days and on their map. Your tips become their trip.</p>
					</div>
					<div className={`${styles.w2V} ${styles.flow2}`} aria-hidden="true">
						<div className={styles.igp}>
							<div className={styles.igh}>
								<span className={styles.iga}>
									<img src={img("ilse-avatar.webp")} alt="" className={styles.avatarFill} />
								</span>
								<b>ilseandreajansen</b>
							</div>
							<img src={img("madeira-pol.webp")} alt="" />
							<div className={styles.igf}>
								<Heart />
								<Comment />
								<span className={styles.bm}>
									<Bookmark />
								</span>
							</div>
							<span className={styles.saved}>Saved · and forgotten</span>
						</div>
						<span className={styles.farr}>
							<Chevron />
						</span>
						<div className={styles.tph}>
							<img src={img("app-list.webp")} alt="" />
						</div>
						<span className={`${styles.pop} ${styles.p1}`}>
							<span className={styles.pb}>
								<span className={styles.pi2}>
									<img src={img("booking.webp")} alt="Booking.com" />
								</span>
								<span>
									<b>You earned €18.40</b>
									<small>Hotel booked via your link</small>
								</span>
							</span>
						</span>
						<span className={`${styles.pop} ${styles.p2}`}>
							<span className={styles.pb}>
								<span className={styles.pi2}>
									<img src={img("getyourguide.webp")} alt="GetYourGuide" />
								</span>
								<span>
									<b>You earned €6.20</b>
									<small>Food tour booked via your link</small>
								</span>
							</span>
						</span>
						<span className={`${styles.pop} ${styles.p3}`}>
							<span className={styles.pb}>
								<span className={styles.pi2}>
									<span className={styles.pis}>
										<SMark />
									</span>
								</span>
								<span>
									<b>You earned €0.50</b>
									<small>A new traveller planned a trip</small>
								</span>
							</span>
						</span>
					</div>
				</article>
			</div>
		</div>
	</section>
);

export const Affiliate = () => (
	<section className={styles.affsec} aria-labelledby="aff-h">
		<div className={`${styles.wrap} ${styles.affg}`}>
			<div className={styles.affCopy}>
				<span className={styles.eyebrow}>
					<Link fill="#0b8a63" /> Your affiliate links
				</span>
				<h2 className={styles.h2} id="aff-h">
					Your affiliate links, <span className={styles.hl}>finally booked</span>
				</h2>
				<p className={styles.lede}>
					A link in your Linktree gets one look and is forgotten. In Stippl your links are saved inside your followers' travel plan, right next to the places
					you recommend. When they sit down to book, weeks later, your link is still there.
				</p>
				<ul className={styles.affl}>
					<li>
						<b>Any program you already use</b>Booking.com, GetYourGuide, Viator, Airbnb, eSIMs or your own discount codes.
					</li>
					<li>
						<b>On every place, trip and list</b>Add a link once and it travels with every copy of your route.
					</li>
					<li>
						<b>100% of the commission is yours</b>Stippl doesn't take a cut of your own links. Ever.
					</li>
				</ul>
			</div>
			<div className={styles.affVis} aria-hidden="true">
				<div className={styles.w2V} aria-hidden="true">
					<div className={styles.pcard}>
						<img src={img("holbox.webp")} alt="" />
						<span>
							<b>Their trip · Mexico City</b>
							<small>Day 1 to 4 of Mexico in 3 weeks</small>
						</span>
					</div>
					<div className={styles.arow}>
						<span className={styles.al}>
							<img src={img("booking.webp")} alt="Booking.com" />
						</span>
						<span>
							<b>My hotel pick in Roma Norte</b>
							<small>Booking.com</small>
						</span>
						<em>Your link</em>
					</div>
					<div className={styles.arow}>
						<span className={styles.al}>
							<img src={img("getyourguide.webp")} alt="GetYourGuide" />
						</span>
						<span>
							<b>Street food tour</b>
							<small>GetYourGuide</small>
						</span>
						<em>Your link</em>
					</div>
					<div className={styles.arow}>
						<span className={`${styles.al} ${styles.es}`}>
							<Esim />
						</span>
						<span>
							<b>Mexico eSIM</b>
							<small>With your code</small>
						</span>
						<em>Your code</em>
					</div>
				</div>
				<div className={styles.earnbox}>
					<span className={styles.ebH}>Your links this month</span>
					<div className={styles.ebR}>
						<span className={styles.al}>
							<img src={img("booking.webp")} alt="" />
						</span>
						<span>Booking.com</span>
						<b>€184</b>
					</div>
					<div className={styles.ebR}>
						<span className={styles.al}>
							<img src={img("getyourguide.webp")} alt="" />
						</span>
						<span>GetYourGuide</span>
						<b>€62</b>
					</div>
					<div className={styles.ebR}>
						<span className={`${styles.al} ${styles.es}`}>
							<Esim />
						</span>
						<span>eSIM codes</span>
						<b>€38</b>
					</div>
					<small>Example</small>
				</div>
			</div>
		</div>
	</section>
);

export const YourPage = () => (
	<section id="example" aria-labelledby="ex-h" className={styles.yourpage}>
		<div className={`${styles.wrap} ${styles.yp}`}>
			<div className={styles.ypCopy}>
				<span className={styles.eyebrow}>Your page on Stippl</span>
				<h2 className={styles.h2} id="ex-h">
					One page for <span className={styles.hl}>everything you share</span>
				</h2>
				<p className={styles.lede}>Every creator gets a profile at stippl.io/c/yourname. You write the intro, we pull in the rest.</p>
				<ul className={styles.ypList}>
					<li>
						<b>Your intro</b>Photo, a few lines about you, your socials.
					</li>
					<li>
						<b>Your next trip</b>The trip you're planning or on right now, ready to follow and share.
					</li>
					<li>
						<b>All your trips</b>Every route you planned, one tap to copy, with all your affiliate links included.
					</li>
					<li>
						<b>Guides and lists</b>Free or paid, with a map attached and your affiliate links included.
					</li>
					<li>
						<b>Your name on every preview</b>Shared trips and lists show who recommended them, and why.
					</li>
				</ul>
				<a className={`${styles.btn} ${styles.btnGreen}`} href={CREATOR_PAGE_PATH}>
					See Ilse's page →
				</a>
			</div>
			<a className={styles.ypShot} href={CREATOR_PAGE_PATH} aria-label="Open Ilse's creator page">
				<span className={styles.bar}>
					<i></i>
					<i></i>
					<i></i>
					<span>stippl.io/c/ilseandreajansen</span>
				</span>
				<img src={img("profile-shot.webp")} alt="Ilse's creator page on Stippl" loading="lazy" />
			</a>
		</div>
	</section>
);

export const Promo = () => (
	<section className={styles.promo2} aria-labelledby="promo-h">
		<div className={styles.wrap}>
			<div className={styles.secHead}>
				<span className={styles.eyebrow}>We promote you</span>
				<h2 className={styles.h2} id="promo-h">
					Your content, in front of <span className={styles.hl}>our travellers</span>
				</h2>
			</div>
			<div className={styles.p2grid}>
				<div className={styles.p2}>
					<i>
						<Star />
					</i>
					<b>In the Stippl app</b>
					<p>Travellers planning your city see your profile, your lists and your routes while they plan.</p>
				</div>
				<div className={styles.p2}>
					<i>
						<MapPin fill="#0e9e73" />
					</i>
					<b>On our Discover pages</b>
					<p>Your routes and local picks on the destination pages people find through Google.</p>
				</div>
				<div className={styles.p2}>
					<i>
						<Document fill="#7c3aed" />
					</i>
					<b>On the Stippl blog</b>
					<p>We link your lists and routes in our travel guides, as a local tip or the route to follow, with your name on it.</p>
				</div>
				<div className={styles.p2}>
					<i>
						<Instagram fill="#c13584" />
					</i>
					<b>On our socials</b>
					<p>We share your routes and lists on Stippl's Instagram and TikTok, tagged and credited to you.</p>
				</div>
			</div>
		</div>
	</section>
);

export const ChatGpt = () => (
	<section className={styles.gptSec} aria-labelledby="gpt-h">
		<div className={`${styles.wrap} ${styles.split}`}>
			<div className={styles.secHead} style={{ margin: 0 }}>
				<span className={styles.eyebrow} id="how">
					How it works
				</span>
				<h2 className={styles.h2} id="gpt-h">
					Paste your posts into ChatGPT. Get a trip in Stippl.
				</h2>
				<p className={styles.lede}>
					Stippl works inside ChatGPT. Drop in your captions, a blog post or your saved Google Maps list, ask ChatGPT to turn it into a trip, and it lands in
					your Stippl account, day by day. No template to fill in.
				</p>
				<ol className={styles.steps3}>
					<li>
						<span>
							<b>Apply</b> and tell us which place you know best.
						</span>
					</li>
					<li>
						<span>
							<b>Create your trips</b> by pasting your posts into ChatGPT, or send us a list.
						</span>
					</li>
					<li>
						<span>
							<b>Share your page</b> and get paid every month.
						</span>
					</li>
				</ol>
			</div>
			<div className={styles.gptstage}>
				<div className={styles.gpt} aria-label="Example: saving Madeira hikes to Stippl from ChatGPT">
					<div className={styles.top}>
						<i></i>
						<i></i>
						<i></i>
						<span>ChatGPT</span>
					</div>
					<div className={styles.body}>
						<div className={styles.att}>
							<span className={styles.ch}>
								<img src={img("madeira-pol.webp")} alt="" />
								<span>
									<b>Reel</b>Hiking Madeira
								</span>
							</span>
							<span className={styles.ch}>
								<span className={styles.ic}>
									<Document fill="#0b8a63" />
								</span>
								<span>
									<b>Blog post</b>yourblog.com/madeira
								</span>
							</span>
							<span className={styles.ch}>
								<span className={`${styles.ic} ${styles.gm}`}>
									<MapPin fill="#ea4335" />
								</span>
								<span>
									<b>Google Maps</b>Madeira hikes · 11
								</span>
							</span>
						</div>
						<div className={styles.u}>Turn these into a 5-day Madeira trip and save it to Stippl.</div>
						<div className={styles.a}>
							<div className={styles.tool}>
								<img src={img("guide-cover.webp")} alt="" />
								<span>
									<small>
										<SMark />
										Stippl · trip created
									</small>
									<b>Madeira in 5 days</b>
									<em>5 days · 9 stops</em>
								</span>
								<span className={styles.ok}>✓</span>
							</div>
							<p>Done! Your 5-day Madeira trip is in your Stippl account, ready to share. 🎉</p>
						</div>
					</div>
				</div>
				<div className={styles.gphone} aria-hidden="true">
					<img src={img("app-list.webp")} alt="" />
				</div>
				<span className={styles.gbadge} aria-hidden="true">
					In your Stippl account
				</span>
			</div>
		</div>
	</section>
);

export const Meet = () => (
	<section aria-labelledby="meet-h">
		<div className={styles.wrap}>
			<div className={styles.secHead}>
				<span className={styles.eyebrow}>Meet the creators</span>
				<h2 className={styles.h2} id="meet-h">
					The people behind the <span className={styles.hl}>routes</span>
				</h2>
				<p className={styles.lede}>Travellers browse creators by destination and follow the ones they trust. More creators are announced soon.</p>
			</div>
			<div className={styles.cgrid}>
				<a className={styles.cc} href={CREATOR_PAGE_PATH}>
					<span className={styles.ccPh}>
						<img src={img("madeira-pol.webp")} alt="" loading="lazy" />
						<span className={styles.live} style={{ color: "var(--green-ink)" }}>
							● Next up: Mexico
						</span>
					</span>
					<span className={styles.ccB}>
						<span className={styles.ccAv}>
							<img src={img("ilse-avatar.webp")} alt="" />
						</span>
						<b>Ilse Jansen</b>
						<small>🇳🇱 Based in Amsterdam · @ilseandreajansen</small>
						<span className={styles.ccS}>
							<span>
								<b>8</b> trips
							</span>
							<span>
								<b>2</b> lists
							</span>
						</span>
						<span className={styles.ccGo}>View profile →</span>
					</span>
				</a>
				<div className={`${styles.cc} ${styles.soon}`}>
					<span className={styles.ccPh}>
						<img src={img("portrait.webp")} alt="" loading="lazy" />
					</span>
					<span className={styles.ccB}>
						<span className={`${styles.ccAv} ${styles.q}`}>+</span>
						<b>More creators</b>
						<small>Announced soon</small>
						<span className={styles.ccTxt}>New creators are joining Stippl. Want to be one of them?</span>
						<a className={styles.ccGo} href="#apply">
							Apply now →
						</a>
					</span>
				</div>
			</div>
		</div>
	</section>
);

export const Faq = () => (
	<section id="faq" aria-labelledby="faq-h" className={styles.faq2}>
		<div className={`${styles.wrap} ${styles.faqgrid}`}>
			<div className={styles.faqside}>
				<span className={styles.eyebrow}>FAQ</span>
				<h2 className={styles.h2} id="faq-h">
					Questions creators ask
				</h2>
				<div className={styles.ph4}>
					<img src={img("madeira-pol.webp")} alt="Ilse hiking on Madeira" loading="lazy" />
					<span className={styles.q}>
						“I plan every trip in Stippl anyway. Now my followers can copy them in one tap.”<small>Ilse, Stippl creator</small>
					</span>
				</div>
			</div>
			<div className={styles.faq}>
				<details open>
					<summary>What counts as an active traveller?</summary>
					<p>
						Someone who joins Stippl through your link, page, embedded map or code, and then plans at least one trip. Sign-ups that never plan a trip don't
						count, and each person counts once.
					</p>
				</details>
				<details>
					<summary>Does it cost anything?</summary>
					<p>No. There's no fee to join and no upfront cost.</p>
				</details>
				<details>
					<summary>Can I put the map on my website?</summary>
					<p>
						Yes. You get an embed code for your map and your routes. Readers can explore it on your page and save it to Stippl, and every one of them who plans
						a trip counts as yours.
					</p>
				</details>
				<details>
					<summary>How much do I earn on a guide?</summary>
					<p>
						80% of the revenue from every paid guide you sell through Stippl. You set the price with us, between €9.99 and €14.99. You don't have to sell one: a
						free map already earns you €0.50 for every follower who plans a trip.
					</p>
				</details>
				<details>
					<summary>Can I use my own affiliate links?</summary>
					<p>Yes. Add the hotel, tour and eSIM links you already use. That commission goes straight to you, the same as on your other channels.</p>
				</details>
				<details>
					<summary>Who owns the content?</summary>
					<p>
						Your words and photos stay yours. You give Stippl a licence to use them in your map, trips, translations and promotion. If we stop working together,
						your map comes down.
					</p>
				</details>
				<details>
					<summary>How many followers do I need?</summary>
					<p>
						There's no minimum. What matters most is that your followers come to you for one place. A focused account of 20,000 often brings in more travellers
						than a general one of 500,000.
					</p>
				</details>
				<details>
					<summary>How and when do I get paid?</summary>
					<p>Monthly, with a statement of every traveller you brought in. Payouts start once you've earned €50.</p>
				</details>
			</div>
		</div>
	</section>
);
